import client from "../Client/HttpClient";
import { ISystemTemplatesModel } from "@/interfaces/modules";
const ApiPath = "SystemTemplates";

export default {
  GetTemplates: (): Promise<ISystemTemplatesModel[]> => client.get(`${ApiPath}`),
  GetTemplatesById: (data: ISystemTemplatesModel): Promise<ISystemTemplatesModel> =>
    client.get(`${ApiPath}/${data.Id}`),
  PostTemplates: (data: ISystemTemplatesModel): Promise<ISystemTemplatesModel> =>
    client.post(`${ApiPath}`, data),
};
